$toast-width: min(calc(100vw - 16px), 300px);

:global([data-sonner-toaster]) {
  z-index: 9999999999 !important;
  font-family: Vazirmatn, sans-serif !important;
  width: $toast-width !important;
}

@media (max-width: 600px) {
  :global([data-sonner-toaster]) {
    left: 50% !important;
    right: auto !important;
    transform: translateX(-50%) !important;
    width: $toast-width !important;
  }

  :global([data-sonner-toaster] [data-sonner-toast]) {
    left: 0 !important;
    right: 0 !important;
    width: 100% !important;
  }
}

.toast {
  --font-size: var(--font-size-small);
  --dismiss-size: var(--font-size-large);
  --dismiss-font-weight: var(--font_weight-black);

  border-radius: 50px !important;
  padding: 12px 16px !important;
  width: 100% !important;
  min-height: unset !important;
  font-size: var(--font-size) !important;
  font-family: Vazirmatn, sans-serif !important;
  display: flex !important;
  align-items: center;
  justify-content: space-between;
  gap: var(--spacing-16) !important;
  direction: rtl;
  color: #fff !important;
  background: var(--tap-palette-black) !important;
  border: none !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;

  :global([data-icon]),
  :global([data-content]) {
    order: 0;
  }

  :global([data-icon]) {
    margin: 0 !important;
  }

  :global([data-content]) {
    flex: 1;
    min-width: 0;
    overflow: hidden;
  }
}

.icon {
  width: 24px;
  height: 24px;
  color: #fff !important;
}

.info {
  background: var(--tapsi-color-surface-accent) !important;
}

.success {
  background: var(--tapsi-color-surface-positive) !important;
}

.error {
  background: var(--tapsi-color-surface-negative) !important;
}

.inverse {
  background: var(--tapsi-color-surface-inverse-secondary) !important;
}

.warning {
  background: var(--tapsi-color-surface-warning) !important;
  color: var(--tap-color-text-primary) !important;

  .dismiss {
    color: var(--tap-color-text-primary) !important;

    &:hover {
      background-color: rgba(0, 0, 0, 0.12) !important;
    }

    svg {
      color: var(--tap-color-text-primary) !important;
      stroke: var(--tap-color-text-primary) !important;
    }
  }
}

.dismiss {
  order: 1;
  position: static !important;
  transform: none !important;
  flex-shrink: 0;
  width: 16px !important;
  height: 16px !important;
  margin: 0 !important;
  padding: 0 !important;
  background-color: transparent !important;
  color: #fff !important;
  font-weight: var(--dismiss-font-weight) !important;
  font-size: var(--dismiss-size) !important;
  border: none !important;
  box-shadow: none !important;

  &:hover {
    background-color: rgba(255, 255, 255, 0.12) !important;
  }

  svg {
    color: #fff !important;
    stroke: #fff !important;
  }
}
